<div class="category-header d-flex px-3 row py-3">
  <div class="col-md-8 d-flex">
    <span
      nzType="arrow-left"
      nz-icon
      [routerLink]="[
        '/content-list',
        defaultPageType ? defaultPageType : pageType,
      ]"
    >
    </span>
    <h5 class="mb-0 px-2">{{ contentName }}</h5>
  </div>
  <div class="col-md-4 d-flex justify-content-end">
    <a
      class="mr-10"
      [routerLink]="[
        '/content-list',
        defaultPageType ? defaultPageType : pageType,
      ]"
      nz-button
      [nzSize]="'default'"
      nzType="link"
      >Cancel</a
    >
    <button
      class="mr-10"
      nz-button
      [nzSize]="'default'"
      nzType="primary"
      (click)="addContentData()"
    >
      Save
    </button>
    <button
      class="mr-10"
      nz-button
      *ngIf="editPage"
      (click)="linkDrawer = !linkDrawer"
      [nzSize]="'default'"
      nzType="primary"
    >
      {{
        apiService.contentPageType == "W" || apiService.contentPageType == "N"
          ? "Linked AR/EDP/Program"
          : "Linked AR/EDP"
      }}
    </button>
  </div>
</div>
<div class="px-4 mt-4">
  <div class="header d-flex row align-items-center">
    <div class="col-md-6">
      <h5 class="px-4 py-3">
        {{ apiService.contentPageDesc }} - Content Details
      </h5>
    </div>
    @if (
      apiService.contentPageType != "CO" &&
      apiService.contentPageType != "O" &&
      apiService.contentPageType != "W" &&
      apiService.contentPageType != "ON" &&
      apiService.contentPageType != "NL" &&
      apiService.contentPageType != "BI"
    ) {
      <ng-container>
        <div
          class="col-md-6 px-4 d-flex justify-content-end align-items-center align-self-center"
        >
          <div class="px-4">
            <label class="form-label mb-0 px-1">Collapse All</label>
            <nz-switch class="toggle" (click)="collapseAll()"></nz-switch>
          </div>
          <button
            nz-button
            nzType="default"
            (click)="addItemtoDescArray('addNew')"
            class="d-flex align-items-center"
            [nzSize]="'default'"
          >
            <span nz-icon nzType="plus"></span>Add New
          </button>
        </div>
      </ng-container>
    }
  </div>
  <div class="wrapper">
    <form [formGroup]="addEditContentForm">
      <div class="form-container row">
        @for (field of contentPageFields; track field.id) {
          @if (
            field.fieldType == "input" &&
            field.pageTypes.includes(apiService.contentPageType)
          ) {
            <ng-container>
              <div class="col-md-6 mb-5">
                <label class="form-label">
                  {{ field.fieldName }}
                  @if (field.required) {
                    <span class="text-danger">*</span>
                  }
                </label>
                @if (field.formControlName == "clientSecret") {
                  <div class="input-wrapper">
                    <input
                      [attr.maxlength]="field.maxLength"
                      class="form-control"
                      placeholder="{{ field?.placeholder }}"
                      formControlName="{{ field?.formControlName }}"
                      [type]="viewSecret ? 'text' : 'password'"
                      class="form-control"
                      placeholder="******"
                    />
                    <!-- <span style="cursor: pointer;" (click)="togglePassword()" nz-icon
                            [nzType]="viewPassword ? 'eye':'eye-invisible'"></span> -->
                    <img
                      style="cursor: pointer"
                      (click)="viewSecret = !viewSecret"
                      [src]="
                        viewSecret ? 'eye-visible.svg' : 'eye-invisible.svg'
                      "
                      width="18px"
                      height="18px"
                    />
                  </div>
                } @else {
                  <input
                    type="text"
                    [attr.maxlength]="field.maxLength"
                    class="form-control"
                    placeholder="{{ field?.placeholder }}"
                    formControlName="{{ field?.formControlName }}"
                  />
                }
                <span
                  class="text-danger"
                  *ngIf="
                    field.required &&
                    !addEditContentForm.get(field?.formControlName)?.value &&
                    (addEditContentForm.get(field?.formControlName)?.touched ||
                      inValidAddEditContentForm)
                  "
                >
                  {{ field?.fieldName }} is required.
                </span>
              </div>
              @if (
                apiService.contentPageType != "BI" ||
                ["menuTitle", "content"].includes(field?.formControlName)
              ) {
                <div class="col-md-6 mb-5"></div>
              }
            </ng-container>
          } @else if (
            field.fieldType == "textarea" &&
            field.pageTypes.includes(apiService.contentPageType)
          ) {
            <ng-container>
              <div
                class="col-md-6"
                [ngClass]="
                  field.formControlName == 'url' ? 'col-md-12' : 'col-md-6'
                "
              >
                <label class="form-label">
                  {{ field.fieldName }}
                  @if (field.required) {
                    <span class="text-danger">*</span>
                  }
                </label>

                @if (field.richTextEditor) {
                  <app-rich-text-field
                    class="col-md-12 mb-2"
                    (paste)="onPaste($event)"
                    [placeholder]="field['placeholder'] || ''"
                    formControlName="{{ field['formControlName'] }}"
                    [toolbar]="field['toolBar'] || toolbar"
                  ></app-rich-text-field>
                } @else {
                  <textarea
                    type="text"
                    [rows]="field.formControlName == 'url' ? 2 : 4"
                    class="form-control"
                    placeholder="{{ field?.placeholder }}"
                    formControlName="{{ field?.formControlName }}"
                  ></textarea>
                }

                <span
                  class="text-danger"
                  *ngIf="
                    field.required &&
                    !addEditContentForm.get(field?.formControlName)?.value &&
                    (addEditContentForm.get(field?.formControlName)?.touched ||
                      inValidAddEditContentForm)
                  "
                >
                  {{ field?.fieldName }} is required.
                </span>
              </div>
            </ng-container>
          } @else if (
            field.fieldType == "accordion" &&
            field.pageTypes.includes(apiService.contentPageType)
          ) {
            <div
              cdkDropList
              [cdkDropListData]="descArrayArrayControls"
              cdkDropListOrientation="vertical"
              (cdkDropListDropped)="drop($event, descArrayArrayControls)"
              class="row"
            >
              <ng-container formArrayName="descArray">
                <div
                  class="col-md-12"
                  *ngFor="let descForm of descArrayArrayControls; let i = index"
                >
                  <nz-collapse
                    ngM
                    cdkDrag
                    class="mb-3"
                    style="background-color: #ffff"
                    nzAccordion
                  >
                    <nz-collapse-panel
                      #panelRef
                      [nzExtra]="customExpandIcon"
                      [nzExpandedIcon]="holderIcon"
                      [nzHeader]="
                        descArray.value[i].title
                          ? descArray.value[i].title
                          : 'Untitled'
                      "
                      [nzActive]="field?.collapse"
                    >
                      <div [formGroup]="descForm">
                        @for (panel of field.fields; track panel) {
                          @if (panel.fieldType == "input") {
                            <ng-container>
                              <div class="col-md-12 mb-1">
                                <label class="form-label">
                                  {{ panel.fieldName }}
                                  @if (field.required) {
                                    <span class="text-danger">*</span>
                                  }
                                </label>
                                <input
                                  type="text"
                                  class="form-control"
                                  [maxlength]="panel.maxLength"
                                  placeholder="{{ panel?.placeholder }}"
                                  formControlName="{{ panel?.formControlName }}"
                                />
                                <span
                                  class="text-danger"
                                  *ngIf="
                                    field.required &&
                                    !descForm.get(panel?.formControlName)
                                      ?.value &&
                                    (descForm.get(panel?.formControlName)
                                      ?.touched ||
                                      inValidAddEditContentForm)
                                  "
                                >
                                  {{ field?.fieldName }} is required.
                                </span>
                              </div>
                            </ng-container>
                          } @else if (panel.fieldType == "textarea") {
                            <ng-container>
                              <div class="col-md-12">
                                <label class="form-label">
                                  {{ panel.fieldName }}
                                  @if (field.required) {
                                    <span class="text-danger">*</span>
                                  }
                                </label>

                                <app-rich-text-field
                                  [placeholder]="panel?.placeholder"
                                  formControlName="{{ panel?.formControlName }}"
                                  (paste)="onPaste($event)"
                                  [toolbar]="toolbar"
                                ></app-rich-text-field>

                                <span
                                  class="text-danger"
                                  *ngIf="
                                    field.required &&
                                    !descForm.get(panel?.formControlName)
                                      ?.value &&
                                    (descForm.get(panel?.formControlName)
                                      ?.touched ||
                                      inValidAddEditContentForm)
                                  "
                                >
                                  {{ field?.fieldName }} is required.
                                </span>
                              </div>
                            </ng-container>
                          }
                        }
                        <ng-template #customExpandIcon>
                          <div class="extra-icon-block d-flex">
                            <i
                              *ngIf="descArray.length > 1"
                              class="delete-icon px-2"
                              nz-icon
                              nzType="delete"
                              (click)="deleteDescArrayItem(i)"
                            ></i>
                            <i
                              class="expand-icon"
                              (click)="handleCollapse(i)"
                              nz-icon
                              [nzType]="
                                !this.addEditContentForm.get('descArray')
                                  ?.value[i].collapse
                                  ? 'up'
                                  : 'down'
                              "
                            ></i>
                          </div>
                        </ng-template>
                        <ng-template #holderIcon>
                          <i
                            class="holder-icon px-3"
                            cdkDragHandle
                            nz-icon
                            nzType="holder"
                          ></i>
                        </ng-template>
                      </div>
                    </nz-collapse-panel>
                  </nz-collapse>
                </div>
              </ng-container>
            </div>
          } @else if (
            field.fieldType == "inputblock" &&
            field.pageTypes.includes(apiService.contentPageType)
          ) {
            <div class="add-catalog-form p-4 mt-4 row">
              <ng-container>
                <div class="col-md-12 px-1 mb-2">
                  <h6 class="mb-1">{{ field.sectionTitle }}</h6>
                  <p class="text-muted mb-0">{{ field.sectionDescription }}</p>
                </div>
                <div class="mb-1 px-1 col-md-7 position-relative mt-3">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter Email"
                    formControlName="email"
                    (input)="clearEmailErrors()"
                    (keydown.enter)="
                      $event.preventDefault();
                      $event.stopPropagation();
                      addEmail()
                    "
                  />
                  <span class="error-text" *ngIf="emailError">
                    Please enter a valid Email address
                  </span>
                  <span class="error-text" *ngIf="emailEmpty">
                    {{ field?.fieldName }} is required
                  </span>
                  <span class="error-text" *ngIf="emailDuplicate">
                    This email has already been added
                  </span>
                </div>
                <div class="col-md-1 mt-3 px-1">
                  <button
                    class="d-flex px-4 align-items-center justify-content-center"
                    nz-button
                    nzType="default"
                    (click)="addEmail()"
                  >
                    Add
                  </button>
                </div>
                @if (emailArray.value.length > 0) {
                  <div class="lot-keyword-section mt-2 mb-2 p-3">
                    <div class="d-flex flex-wrap mt-2 w-100">
                      @for (
                        tag of emailArray.controls;
                        let j = $index;
                        track tag
                      ) {
                        <nz-tag
                          class="text-wrap mb-2"
                          (nzOnClose)="removeEmail(j)"
                          nzMode="closeable"
                          >{{ tag?.value }}</nz-tag
                        >
                      }
                    </div>
                  </div>
                }
              </ng-container>
            </div>
          }
        }
      </div>
    </form>
  </div>
</div>
<nz-drawer
  [nzMaskClosable]="false"
  [nzWidth]="830"
  [nzKeyboard]="false"
  [nzVisible]="linkDrawer"
  [nzTitle]="
    apiService.contentPageType == 'W' || apiService.contentPageType == 'N'
      ? 'Linked AR/EDP/Program'
      : 'Linked AR/EDP'
  "
  (nzOnClose)="linkDrawer = false"
  [nzExtra]="extra"
>
  <ng-container *nzDrawerContent>
    <app-content-linked
      [seqId]="contentId"
      [contentType]="apiService.contentPageType"
    ></app-content-linked>
  </ng-container>
  <ng-template #extra>
    <button nz-button nzType="default" (click)="linkDrawer = false">
      Close
    </button>
  </ng-template>
</nz-drawer>
